// Module
var code = `<div class="js-certificate-screen">
    <div class="js-certificate-screen-info">
        {{#each .certificateInfoParams}}
            <div class="js-certificate-screen-info-item">
                {{.key}}: {{.value}}
            </div>
        {{/each}}
    </div>
    <div class="js-certificate-screen-buttons">
        {{#if .okCallback}}
        <div class="js-certificate-screen-buttons-button">
            <terceraButton terceraButtonStyle="{{.btnOKStyle}}" text="{{.okText}}" on-btnClick="okClick"/>
        </div>
        {{/if}}
        {{#if .cancelCallback}}
        <div class="js-certificate-screen-buttons-button">
            <terceraButton terceraButtonStyle="{{.btnCancelStyle}}" text="{{.cancelText}}" on-btnClick="cancelClick"/>
        </div>
        {{/if}}
    </div>
</div>

`;
// Exports
export default code;